const types = {
  GET_USER: 'GET_USER',
};

export default types;



/** WEBPACK FOOTER **
 ** ./src/app/redux/actions/actionTypes.js
 **/